<div class="workflow-crud mm-page">
  <h2 class="mb-4">{{_(KEYS.CRUD.WORKFLOW)}}</h2>

  <form [formGroup]="workflowForm">

    <div class="mb-3" formGroupName="name">
      <label for="workflow-name">{{_(KEYS.CRUD.STAGE_NAME)}}</label>
      <input id="workflow-name" class="form-control" formControlName="de_DE" placeholder="{{_(KEYS.CRUD.ENTER_WORKFLOW_NAME)}}" />
    </div>

    <details class="workflow-description" [open]="!!workflowForm.get('description.de_DE').value">
      <summary>{{_(KEYS.CRUD.STAGE_DESCRIPTION)}} <span>{{_(KEYS.CRUD.OPTIONAL)}}</span></summary>
      <div formGroupName="description">
        <textarea class="form-control" formControlName="de_DE" [attr.aria-label]="_(KEYS.CRUD.STAGE_DESCRIPTION)"
                  placeholder="{{_(KEYS.CRUD.ENTER_WORKFLOW_DESCRIPTION)}}"></textarea>
      </div>
    </details>

    <details *ngIf="editorIssues.length" class="workflow-issues">
      <summary><i class="fa fa-info-circle" aria-hidden="true"></i> {{editorIssues.length}} {{_(editorIssues.length === 1 ? KEYS.CRUD.REVIEW_HINT : KEYS.CRUD.REVIEW_HINTS)}}</summary>
      <ul>
        <li *ngFor="let issue of editorIssues">
          <button type="button" (click)="openIssue(issue)">{{issue.label}} <i class="fa fa-angle-right" aria-hidden="true"></i></button>
        </li>
      </ul>
    </details>

    <ul class="nav nav-tabs mt-4">
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab==='steps'" href="javascript:void(0)" (click)="activeTab='steps'">{{_(KEYS.CRUD.STAGES)}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab==='variables'" href="javascript:void(0)" (click)="activeTab='variables'">{{_(KEYS.CRUD.VARIABLES)}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab==='test'" href="javascript:void(0)" (click)="activeTab='test'">{{_(KEYS.CRUD.TEST_FLOW)}}</a>
      </li>
    </ul>

    <div class="tab-content pt-3">
      <div class="tab-pane" [class.active]="activeTab==='steps'">
        <div class="workflow-step-toolbar">
          <span>{{stages.length}} {{_(stages.length === 1 ? KEYS.CRUD.STAGE : KEYS.CRUD.STAGES)}}</span>
          <button *ngIf="stages.length" type="button" class="workflow-text-action"
                  [attr.aria-pressed]="expandAllStages" (click)="toggleAllStages()">
            <i class="fa" [ngClass]="expandAllStages ? 'fa-compress' : 'fa-expand'" aria-hidden="true"></i>
            {{_(expandAllStages ? KEYS.CRUD.COLLAPSE_ALL : KEYS.CRUD.EXPAND_ALL)}}
          </button>
        </div>
        <!-- steps on a light sheet, so the white step cards stand out (like the questionnaire editor) -->
        <div class="workflow-sheet">
        <div *ngIf="!stages.length" class="workflow-empty">
          <i class="fa fa-list-ol" aria-hidden="true"></i>
          <p>{{_(KEYS.CRUD.EMPTY_STEPS)}}</p>
        </div>
        <div class="workflow-insert" *ngIf="stages.length">
          <button type="button" (click)="onAddStage(0)"><i class="fa fa-plus" aria-hidden="true"></i> {{_(KEYS.CRUD.ADD_STAGE)}}</button>
        </div>
        <div formArrayName="stages" cdkDropList [cdkDropListData]="stages.controls" (cdkDropListDropped)="dropStage($event)">
          <ng-container *ngFor="let stage of stages.controls; index as i; trackBy: trackStage">
            <section [formGroupName]="i" cdkDrag [cdkDragData]="stage" [id]="'workflow-step-' + i" tabindex="-1" class="workflow-step" [class.is-expanded]="!collapsedStages[i]">
              <div class="workflow-step-header">
                <span class="workflow-step-number">{{i + 1}}</span>
                <button type="button" cdkDragHandle class="workflow-text-action workflow-drag-handle"
                        [attr.aria-label]="_(KEYS.CRUD.MOVE_STAGE)" [ngbTooltip]="_(KEYS.CRUD.MOVE_STAGE)" container="body">
                  <i class="fa fa-arrows" aria-hidden="true"></i>
                </button>
                <button type="button" class="workflow-step-toggle" (click)="toggleStage(i)"
                        [attr.aria-expanded]="!collapsedStages[i]" [attr.aria-controls]="'workflow-step-body-' + i">
                  <span class="workflow-step-summary">
                    <strong>{{getStageDisplayName(i)}}</strong>
                    <span class="workflow-questionnaire-summary" *ngIf="stage.get('questionnaires').value.length; else noQuestionnaires">
                      <span *ngFor="let id of stage.get('questionnaires').value">{{getQuestionnaireTitle(id)}}</span>
                    </span>
                    <ng-template #noQuestionnaires><span class="workflow-missing">{{_(KEYS.CRUD.NO_QUESTIONNAIRES)}}</span></ng-template>
                  </span>
                  <i class="fa" [ngClass]="collapsedStages[i] ? 'fa-chevron-down' : 'fa-chevron-up'" aria-hidden="true"></i>
                </button>
                <button *ngIf="i > 0; else firstStage" type="button" class="workflow-condition-link"
                        (click)="openStageConditions(i)" [class.has-conditions]="getConditionCount(i) !== 0">
                  <i class="fa fa-code-fork" aria-hidden="true"></i>
                  <ng-container *ngIf="getConditionCount(i) !== 0; else alwaysExecute">
                    <span *ngIf="getConditionCount(i) > 0">{{getConditionCount(i)}}</span>
                    {{_(getConditionCount(i) === 1 ? KEYS.CRUD.CONDITION : KEYS.CRUD.CONDITIONS)}}
                  </ng-container>
                  <ng-template #alwaysExecute>{{_(KEYS.CRUD.VISUAL_ADD_RULE)}}</ng-template>
                </button>
                <ng-template #firstStage><span class="workflow-first-stage">{{_(KEYS.CRUD.ALWAYS_EXECUTE)}}</span></ng-template>
                <div ngbDropdown placement="bottom-right" class="workflow-step-menu">
                  <button type="button" class="workflow-text-action" ngbDropdownToggle [attr.aria-label]="_(KEYS.CRUD.STEP_ACTIONS)">
                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                  </button>
                  <div ngbDropdownMenu>
                    <button type="button" ngbDropdownItem (click)="moveStage(i, i - 1)" [disabled]="i === 0" [attr.disabled]="i === 0 ? '' : null">{{_(KEYS.CRUD.MOVE_UP)}}</button>
                    <button type="button" ngbDropdownItem (click)="moveStage(i, i + 1)" [disabled]="i === stages.length - 1" [attr.disabled]="i === stages.length - 1 ? '' : null">{{_(KEYS.CRUD.MOVE_DOWN)}}</button>
                    <button type="button" ngbDropdownItem (click)="duplicateStage(i)">{{_(KEYS.CRUD.DUPLICATE_STAGE)}}</button>
                    <div class="dropdown-divider"></div>
                    <button type="button" ngbDropdownItem (click)="onRemoveStage(i)">{{_(KEYS.CRUD.DELETE_STAGE)}}</button>
                  </div>
                </div>
              </div>
              <p *ngIf="i === 0" class="workflow-first-condition-note">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <span>{{_(KEYS.CRUD.FIRST_ALWAYS_RUNS)}}. {{_(KEYS.CRUD.VISUAL_FIRST_STEP_HELP)}}</span>
              </p>
              <app-workflow-stage-conditions *ngIf="i > 0" [workflow]="workflowForm.value" [stageIndex]="i"
                [stageKey]="stage" [stageName]="getStageDisplayName(i)" [variables]="conditionVariables"
                [createVariable]="createConditionVariable" (conditionChange)="onStageConditionChange(i, $event)"></app-workflow-stage-conditions>
              <div class="workflow-step-body" [id]="'workflow-step-body-' + i" *ngIf="!collapsedStages[i]">
                <div formGroupName="name" class="mb-3">
                  <label [for]="'workflow-stage-name-' + i">{{_(KEYS.CRUD.STAGE_NAME)}}</label>
                  <input [id]="'workflow-stage-name-' + i" class="form-control" formControlName="de_DE"
                         placeholder="{{_(KEYS.CRUD.ENTER_STAGE_NAME)}}" />
                </div>
                <details class="workflow-description" [open]="!!stage.get('description.de_DE').value">
                  <summary>{{_(KEYS.CRUD.STAGE_DESCRIPTION)}} <span>{{_(KEYS.CRUD.OPTIONAL)}}</span></summary>
                  <div formGroupName="description">
                    <textarea class="form-control" formControlName="de_DE" [attr.aria-label]="_(KEYS.CRUD.STAGE_DESCRIPTION)"
                              placeholder="{{_(KEYS.CRUD.ENTER_STAGE_DESCRIPTION)}}"></textarea>
                  </div>
                </details>
                <section class="workflow-questionnaires" [id]="'workflow-questionnaires-' + i" tabindex="-1">
                  <h3>{{_(KEYS.CRUD.STAGE_QUESTIONNAIRES)}}</h3>
                  <app-questionnaire-select [enableGroups]="true" [enableWorkflows]="false"
                    [selected]="stage.get('questionnaires').value" (selectedChange)="onQuestionnairesSelect($event, i)">
                  </app-questionnaire-select>
                </section>
                <div class="workflow-stage-settings">
                  <fieldset>
                    <legend>{{_(KEYS.CRUD.EXECUTION)}}</legend>
                    <label class="workflow-flag"><input type="checkbox" formControlName="autoStart"> <span>{{_(KEYS.CRUD.AUTO_START_STEP)}}</span></label>
                    <label class="workflow-flag"><input type="checkbox" formControlName="prefill"> <span>{{_(KEYS.CRUD.PREFILL)}}</span></label>
                    <label class="workflow-flag"><input type="checkbox" formControlName="skipSigning"> <span>{{_(KEYS.CRUD.SKIP_SIGNING)}}</span></label>
                  </fieldset>
                  <fieldset>
                    <legend>{{_(KEYS.CRUD.OUTPUT)}}</legend>
                    <label class="workflow-flag"><input type="checkbox" formControlName="generateExports"> <span>{{_(KEYS.CRUD.GENERATE_EXPORTS)}}</span></label>
                    <label class="workflow-flag"><input type="checkbox" formControlName="generateFormPDFs"> <span>{{_(KEYS.CRUD.GENERATE_FORM_PDFS)}}</span></label>
                  </fieldset>
                </div>
                <div class="workflow-step-footer">
                  <button type="button" class="btn btn-danger btn-sm" (click)="onRemoveStage(i)">
                    <i class="fa fa-trash" aria-hidden="true"></i> {{_(KEYS.CRUD.DELETE_STAGE)}}
                  </button>
                </div>
              </div>
            </section>
            <div class="workflow-insert" *ngIf="i < stages.length - 1">
              <button type="button" (click)="onAddStage(i + 1)"><i class="fa fa-plus" aria-hidden="true"></i> {{_(KEYS.CRUD.ADD_STAGE)}}</button>
            </div>
          </ng-container>
        </div>
        <button type="button" id="workflow-add-step" class="btn btn-outline-primary workflow-add-last" (click)="onAddStage()">
          <i class="fa fa-plus" aria-hidden="true"></i> {{_(KEYS.CRUD.ADD_STAGE)}}
        </button>
        </div>
      </div>

      <div class="tab-pane" [class.active]="activeTab==='variables'">
        <p *ngIf="variableWarning" class="alert alert-warning" role="status">{{_(variableWarning)}}</p>
        <app-workflow-variables [workflow]="workflowForm.value" [descriptors]="conditionVariables"
          (edit)="editVariable($event)" (remove)="editVariable($event, true)" (openStage)="openStageConditions($event)"></app-workflow-variables>
      </div>


    </div>

    <app-workflow-test [active]="activeTab === 'test'" [hidden]="activeTab !== 'test'" [workflow]="workflowForm.value" [questionnaires]="allQuestionnaires"
                       (editStage)="openStage($event)"></app-workflow-test>

    <footer class="workflow-save-bar">
      <span class="workflow-save-state" role="status" aria-live="polite">
        <i class="fa" [ngClass]="saving ? 'fa-circle-o-notch fa-spin' : (dirty ? 'fa-circle' : 'fa-check')" aria-hidden="true"></i>
        {{_(saving ? KEYS.CRUD.SAVING : (dirty ? KEYS.CRUD.UNSAVED_CHANGES : KEYS.CRUD.NO_UNSAVED_CHANGES))}}
      </span>
      <button type="button" class="btn btn-primary" [disabled]="!workflowForm.valid || !stages.length || saving || loading" (click)="onSubmit()">
        <i class="fa fa-save" aria-hidden="true"></i> {{_(KEYS.CRUD.SAVE_WORKFLOW)}}
      </button>
    </footer>
  </form>
</div>
